const DOMAIN = {
  DEV: 'https://edelvivesdigital-dev.oneclicklabs.es/',
  DEV_AI: 'https://tenant-ai-2.oneclicklabs.es/',
  QA: 'https://edelvivesdigital-qa.oneclicklabs.es/',
  PROD: 'https://edelvivesdigitalplus.com/',
};

const BASE_DEV = DOMAIN.DEV;

let BASE_AGNOSTIC = window.location.origin + '/';

if (window.location.origin.includes('localhost')) {
  BASE_AGNOSTIC = BASE_DEV;
}

if (window.location.origin.includes('localhost:3018')) {
  BASE_AGNOSTIC = DOMAIN.DEV_AI;
}

export const defaultConfig = { BASE_URL_: BASE_AGNOSTIC, API_URL: BASE_AGNOSTIC + 'api/', BASE_STORAGE_URL: BASE_AGNOSTIC + 'files-storage-tools/' };
